import React from "react";
import "../css/Dashbooard.css";
import { MainContainer } from "../Components/Elements";
import DashbooardHooks from "../hooks/Dashboard/DashboardHooks";
import DynamicDoughnutChart from "../Components/DynamicDoughnutChart";
import CityBarChart from "../Components/CityBarChart";
const Dashbooard = () => {
  let hooks = DashbooardHooks();

  return (
    <>
      <MainContainer>
        <div className="row">
          <div className="col-md-6">
            <DynamicDoughnutChart
              title={hooks.userTypeData.title}
              chartData={hooks.userTypeData.chartData}
              labels={hooks.userTypeData.labels}
            />
          </div>
          <div className="col-md-6">
            <DynamicDoughnutChart
              title={hooks.admistritorfeeData.title}
              chartData={hooks.admistritorfeeData.chartData}
              labels={hooks.admistritorfeeData.labels}
            />
          </div>
        </div>
        <div className="col-md-12">
          <CityBarChart
            data={hooks?.dashboardData?.governorateStatistics}
            loading={hooks.loading}
          />
        </div>
      </MainContainer>
    </>
  );
};

export default Dashbooard;
